import { useTranslation } from "react-i18next";
import RenewalHeader from "./RenewalHeader";
import { Article } from "../../../components/groups";
import RenewalFooter from "./components/RenewalFooter";
import { Footer } from "../../tpa/components/Footer";

interface ErrorProps {
  footerType?: boolean;
}

const Cancelled: React.FC<ErrorProps> = ({ footerType }) => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.payNow.cancelled" });
  const { t: footer } = useTranslation("pages", { keyPrefix: "travel.payNow.hkFooter" });
  const { t: sgfooter } = useTranslation("pages", { keyPrefix: "travel.payNow.sgFooter" });

  return (
    <div className="flex flex-col min-h-screen gap-0">
      <RenewalHeader />
      <div className="container-flow flex-grow mt-6 lg:mt-20">
        <div className="flex gap-10">
          <div className="w-full">
            <h2 className="font-serif font-bold text-4xl mb">{t("title")}</h2>
            <Article>
              <p>{t("content")}</p>
            </Article>
          </div>
        </div>
      </div>
      {footerType ? <RenewalFooter footer={footer} /> : <Footer footer={sgfooter} />}
    </div>
  );
};

export default Cancelled;
